import React, {useContext, useEffect, useState} from "react"
import {CollectionName} from "../../../constants"
import {useTranslation} from "next-i18next"
import DataContext from "../../../context/DataContext"
import FilterDropdownItem from "../dropdown/FilterDropdownItem"
import {ChevronDown, ChevronUp} from "react-bootstrap-icons"
import Typography from "../../reusable/Typography/Typography"
import {useRouter} from "next/router"
import AnalyticsContext from "../../../context/AnalyticsContext"
import {gaCategories, gaEvents} from "../../../config/googleAnalytics/events"

function PreviousFilters({customUrlBaseValue, collectionName}:{customUrlBaseValue?: string, collectionName: CollectionName}) {
	const [previousFilters, setPreviousFilters] = useState({})
	const [data, setData] = useState([])
	const {bikeFilters} = useContext(DataContext)
	const [prevFiltersTabOpen, setPrevFiltersTabOpen] = useState(false)
	const router = useRouter()
	const {reactGA} = useContext(AnalyticsContext)
	const {query: params} = router
	const isSlected = Object.entries(params)
		?.some(([key, value]) => (value as string)
			?.split(",")
			?.some(attribute => attribute !== "-" && data?.some(prevFilter => prevFilter.slug.includes(attribute))))
	const {t} = useTranslation()
	const getPreviousFilters = () => {
		const localStorageData = localStorage.getItem("previousFilters") || "{}"
		const previousFiltersObject = JSON.parse(localStorageData)

		if (typeof previousFiltersObject === "object") {
			setPreviousFilters(previousFiltersObject)
		}
	}

	useEffect(() => {
		getPreviousFilters()
		if (typeof window !== "undefined") {
			window.addEventListener("previousFiltersUpdated", getPreviousFilters)
		}

		return () => window.removeEventListener("previousFiltersUpdated", getPreviousFilters)
	}, [])

	useEffect(() => {
		const result = []
		Object.entries(previousFilters).forEach(([key, value], index) => {
			const valueString = JSON.parse(JSON.stringify(value))
			const filtersSection = bikeFilters.find(filter => filter.slug === key)

			const arr = valueString?.split(",")?.map((option, index) => {
				const categoryObject = filtersSection?.options?.find(cat => option === cat.slug)
				return {
					...categoryObject, slug: `${filtersSection?.slug}:${categoryObject?.slug}`, name: `${filtersSection?.name}: ${categoryObject?.name}`
				}
			}).filter(item => item && !item?.name?.includes("undefined"))
			result.push(...arr)
		})
		setData(() => result)
	}, [previousFilters])
	if (data?.length) {
		return (
			<div className={"mx-auto previous-filters-border  mb-3 col-12"}>
				<div className="accordion">
					<div className="d-grid">
						<button onClick={() => {
							if (!prevFiltersTabOpen) {
								reactGA?.event({
									category: gaCategories.plp,
									action: gaEvents.previousFiltersClicked,
									label: gaEvents.previousFiltersClicked,
									nonInteraction: false
								})
							}

							setPrevFiltersTabOpen(prevState => !prevState)
						}}
						className={`btn py-3 shadow-none px-0 rounded-0 ${prevFiltersTabOpen ? "show" : ""}`}
						type="button"
						data-bs-toggle="dropdown"
						aria-expanded={prevFiltersTabOpen ? "true" : "false"}>
							<div className={"row  d-md-flex g-0"}>
								<Typography variant={isSlected ? "bodyLgBold" : "bodyLg"}
									semanticTag="div"
									className={"col text-start"}>
									{t("previous-filters")}
								</Typography>
								<div className={"col-auto"}>
									{prevFiltersTabOpen ? <ChevronUp/> : <ChevronDown/>}
								</div>
							</div>
						</button>
					</div>
					<div className={`accordion-collapse collapse ${prevFiltersTabOpen ? "show" : null}`}>
						<div className="pb-2 overflow-hidden bg-white w-100 border-0 rounded-0">
							<ul className="px-0 d-flex align-items-start flex-column justify-items-start list-unstyled bike-tabs"
								style={{marginBottom: 0}}>
								{data?.map(category =>
									<div key={category.slug} >
										<FilterDropdownItem className={"gap-0 px-0"}
											key={category.slug}
											isBoxShape={false}
											label={category.name}
											collectionName={collectionName}
											param={category.slug.split(":")[0]}
											value={category.slug.split(":")[1]}/>
									</div>
								)}
							</ul>
						</div>
					</div>
				</div>
			</div>
		)
	}

	return null
}

export default PreviousFilters
